import React, { FC } from 'react'
import styles from 'styles/components/link.module.scss'

type Props = {
  label: string
  url: string
}

const ExternalLink: FC<Props> = React.memo((props) => {
  const { label, url } = props
  return (
    <a className={styles.link} href={url} target={'_blank'} rel={'noopener noreferrer'}>
      {label}
    </a>
  )
})

export default ExternalLink
